<template>
  <div id="print-report">
    <!-- Print Only -->
    <HeaderPrint />
    <!-- / Print Only -->
    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="6" md="9">
            <v-btn
              small
              class="white black--text d-print-none"
              @click="$printReport()"
            >
              <v-icon small left>mdi-printer</v-icon>
              {{ $t("print") }}
            </v-btn>
          </v-col>
          <v-col cols="6" class="d-md-none">
            <div class="text-right">
              <v-btn-toggle dense>
                <v-btn @click="breakpoint = 0">
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>
                <v-btn @click="breakpoint = 'xs'">
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        :search="search"
        class="elevation-0"
        hide-default-footer
        :dense="$vuetify.breakpoint.smAndDown"
        :mobile-breakpoint="breakpoint"
        sort-by="valor"
        :sort-desc="true"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:item.id_lancamento="{ item }">
          <v-btn @click="$copy(item.id_lancamento)" x-small>{{
            item.id_lancamento
          }}</v-btn>
        </template>

        <template v-slot:item.nome_local="{ item }">
          <a
            class="green--text"
            @click="
              $profile.showProfileDrawer(
                item.id_local,
                'administrator/locals/getLocal'
              )
            "
          >
            <v-icon color="green" x-small>mdi-account-multiple</v-icon>
            {{ item.nome_local }}
          </a>
        </template>

        <template v-slot:item.nome_agente="{ item }">
          <a
            @click="
              $profile.showProfileDrawer(
                item.id_agent,
                'administrator/agents/getAgent'
              )
            "
          >
            <v-icon color="blue" x-small>mdi-account</v-icon>
            {{ item.nome_agente }}
          </a>
        </template>
        <template v-slot:item.categoria="{ item }">
          <v-chip
            small
            :color="item.categoria == $t('paid') ? 'red' : 'green'"
            >{{ item.categoria }}</v-chip
          >
        </template>

        <template v-slot:item.valor="{ item }">
          <div :class="item.valor <= 0 ? 'red--text' : 'green--text'">
            {{ item.valor }}
          </div>
        </template>
      </v-data-table>
    </v-card>

    <div class="mt-4" v-if="resume != ''">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-card class="pa-3">
            <div class="subtitle-1 mb-2">{{ $t("resumeSummary") }} <div class="caption"> {{$store.state.rangeUI}}</div> </div>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, i) in resume" :key="i">
                    <td>{{ item.label }}</td>
                    <td :class="getColor(item.value, i)" class="text-right">
                      {{ item.value }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  components: {
    HeaderPrint,
  },
  name: "view-administrator-financial-launches",
  data: () => ({
    items: [],
    search: "",
    resume: "",
    breakpoint: "xs",
  }),
  computed: {
    headers() {
      return [
        { text: "Id", value: "id_lancamento" },
        // { text: "G. Regional", value: "nome_regional" },
        { text: this.$t("mLocal"), value: "nome_local" },
        { text: this.$t("agent"), value: "nome_agente" },
        { text: this.$t("date"), value: "data_lancamento" },
        { text: this.$t("launchedBy"), value: "responsavel_nome" },
        { text: this.$t("receivedPaid"), value: "categoria" },
        { text: this.$t("value"), value: "valor" },
      ];
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_collector() {
      return this.$store.state.filters.autocompleteCollectors.id;
    },
    selectFinancialCategoryAgent() {
      return this.$store.state.filters.selectFinancialCategoryAgent.category;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.historicDeals();
    },
  },
  methods: {
    async historicDeals() {
      const body = {
        ...this.rangeDate,
        id_regional: this.id_regional,
        id_local: this.id_local,
        id_arrecadador: this.id_collector,
        categoria: this.selectFinancialCategoryAgent,
      };
      const response = await this.$request.post(
        "/administrator/financial/historicDeals",
        body
      );

      if (response.length == 0) return;

      // Items Table
      this.items = response.dados.map((item) => {
        // handle Data
        item.data_lancamento = new Date(
          item.data_lancamento.replace(" ", "T")
        ).toLocaleString();
        // handle Categoria (Recebido/Pago)
        item.categoria =
          item.categoria == "14" ? this.$t("received") : this.$t("paid");
        return item;
      });

      // Build Resume
      this.buildResume(this.items);
    },

    // Construindo o Resumo:
    buildResume(data) {
      // Somatório
      const sum = [
        { label: this.$t("releases"), value: data.length },
        { label: this.$t("paid"), value: 0 },
        { label: this.$t("received"), value: 0 },
        { label: this.$t("TOTAL"), value: 0 },
      ];

      // Iterando os valores
      data.forEach((element) => {
        // Soma Pagos:
        sum[1].value =
          element.valor < 0
            ? sum[1].value + Number(element.valor)
            : sum[1].value;
        // Soma recebidos:
        sum[2].value =
          element.valor > 0
            ? sum[2].value + Number(element.valor)
            : sum[2].value;
        // Total:
        sum[3].value = sum[3].value + Number(element.valor);
      });

      // toFixed
      this.resume = sum.map((element) => {
        return {
          label: element.label,
          value: element.value.toFixed(2),
        };
      });
    },

    getColor(value, index) {
      if (value == 0 || index == 0) return "grey--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
};
</script>
